var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('span',[_vm._v("欢迎使用")]),_c('button',{attrs:{"type":"submit"},on:{"click":_vm.logout}},[_vm._v("退出")])])
}
var staticRenderFns = []

export { render, staticRenderFns }